import React from 'react';
import PropTypes from 'prop-types';

function BookIcon({ color = 'black', width = 12, height = 14 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M0 11.333V2.33301C0 1.80257 0.210714 1.29387 0.585787 0.918794C0.960859 0.543722 1.46957 0.333008 2 0.333008H11.3333C11.5101 0.333008 11.6797 0.403246 11.8047 0.52827C11.9298 0.653294 12 0.822863 12 0.999674V12.9997C12 13.1765 11.9298 13.3461 11.8047 13.4711C11.6797 13.5961 11.5101 13.6663 11.3333 13.6663H2.33333C1.71449 13.6663 1.121 13.4205 0.683418 12.9829C0.245833 12.5453 0 11.9518 0 11.333ZM10.6667 12.333V10.333H2.33333C2.06812 10.333 1.81376 10.4384 1.62623 10.6259C1.43869 10.8134 1.33333 11.0678 1.33333 11.333C1.33333 11.5982 1.43869 11.8526 1.62623 12.0401C1.81376 12.2277 2.06812 12.333 2.33333 12.333H10.6667ZM4.66667 1.66634H2C1.82319 1.66634 1.65362 1.73658 1.5286 1.8616C1.40357 1.98663 1.33333 2.1562 1.33333 2.33301V9.22434C1.64579 9.07597 1.98743 8.99921 2.33333 8.99967H10.6667V1.66634H9.33333V6.99967L7 5.66634L4.66667 6.99967V1.66634Z"
        fill={color}
      />
    </svg>
  );
}

BookIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default BookIcon;
